<template>
  <div class="c-app flex-row align-items-center ">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol
          md="8"
          lg="5"
        >
          <CCard class="mx-4 mb-0">
            <CCardBody class="p-4 px-5">
              <CForm
                v-if="validToken"
                class="d-flex flex-column"
              >
                <p class="text-center font-weight-bold mb-4 text-uppercase">
                  Forgot Password?
                </p>
                <CInput
                  v-model="formData.password"
                  :placeholder="'Password'"
                  :type="passwordOpen ? 'text': 'password'"
                  autocomplete="new-password"
                  :add-input-classes="{'is-invalid': hasError('password', 'formData')}"
                  :invalid-feedback="getError('password', 'formData')"
                >
                  <template #append-content>
                    <i
                      class="fas "
                      :class="{'fa-eye': !passwordOpen, 'fa-eye-slash': passwordOpen}"
                      @click="passwordOpen = !passwordOpen"
                    />
                  </template>
                </CInput>
                <CInput
                  v-model="formData.password_confirmation"
                  :placeholder="'Confirm Password'"
                  :type="passwordOpen ? 'text': 'password'"
                  autocomplete="new-password"
                  class="mb-4"
                  :add-input-classes="{'is-invalid': hasError('password_confirmation', 'formData')}"
                  :invalid-feedback="getError('password_confirmation', 'formData')"
                >
                  <template #append-content>
                    <i
                      class="fas "
                      :class="{'fa-eye': !passwordOpen, 'fa-eye-slash': passwordOpen}"
                      @click="passwordOpen = !passwordOpen"
                    />
                  </template>
                </CInput>
                <p
                  v-if="hasError('email')"
                  class="text-danger"
                >
                  {{ getError('email') }}
                </p>
                <CButton
                  color="primary"
                  class="px-5 mb-3 align-self-center text-uppercase"
                  @click="save"
                >
                  Send
                </CButton>
              </CForm>
              <div
                v-if="checkingToken"
                class="d-flex justify-content-center"
              >
                <CSpinner />
              </div>
              <div
                v-if="!validToken && !checkingToken"
                class="text-center"
              >
                Link was expired
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
  import hasApiValidation from "@/mixins/hasApiValidation";
  import { maxLength, minLength, required, sameAs} from "@vuelidate/validators";

  export default {
    name: 'ResetPassword',
    mixins: [hasApiValidation],
    data() {
      return {
        formData: {
          token: '',
          email: '',
          password: '',
          password_confirmation: '',
        },
        checkingToken: true,
        passwordOpen: false,
        loading: true,
        validToken: false,
      }
    },
    validations: {
      formData: {
        password: {
          required: required,
          minLength: minLength(8),
          maxLength: maxLength(32),
        },
        password_confirmation: {
          required: required,
          sameAs: sameAs('password'),
          minLength: minLength(8),
          maxLength: maxLength(32),
        }
      }
    },
    watch: {
      'formData.password': function () {
        this.clearError('password');
        this.v$.$touch();
      },
      'formData.password_confirmation': function () {
        this.v$.$touch();
      },
    },
    mounted() {
      this.formData.token = this.$route.query.token  ?? '';
      this.formData.email = this.$route.query.email ?? '';
      this.checkToken();
    },
    methods: {
      checkToken() {
        this.$http.get('/auth/reset-password', {
          params: {
            token: this.formData.token,
            email: this.formData.email
          }
        })
            .then(() => {
              this.validToken = true;
            })
            .finally(() => {
              this.checkingToken = false;
              this.loading = false;
            })
      },
      save() {
        this.loading = true;
        this.setErrors({});
        this.$http.post('/auth/reset-password', this.formData)
            .then(({data}) => {
              this.setErrors({});
              this.$toast.success(data.message);
              this.$router.push('login');
            })
            .catch(({response}) => {
              if (response && response.data.message) {
                this.$toast.error(response.data.message);
              }
              this.setErrors(response.data.errors);
            })
            .finally(() => {
              this.loading = false;
            });
      },
      validate() {
        return !this.v$.$invalid;
      },
    }
  }
</script>
